<template>
  <div>
    <card v-if="spinning">
      <div class="row">
        <div class="col-sm-12 text-center">
          <b-spinner variant="primary" label="Spinning"></b-spinner>
          <p v-if="pollCount > 0" class="mt-3">
            Generating Quest Reports... ({{ formatElapsedTime() }})
            <br>
            <small class="text-muted">This typically takes 10-15 minutes. Please keep this page open.</small>
          </p>
        </div>
      </div>
    </card>
    <card>
      <div class="row">
        <div class="col-sm-4 text-center">
          <datepicker
            class="editable editable-click"
            :bootstrap-styling="true"
            :format="customFormatter"
            placeholder="Start Date"
            v-model="start_date">
          </datepicker>
        </div>
        <div class="col-sm-4 text-center">
          <datepicker
            class="editable editable-click"
            :bootstrap-styling="true"
            :format="customFormatter"
            placeholder="End Date"
            v-model="end_date">
          </datepicker>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-4"></div>
        <div class="col-sm-4">
          <button class="btn-primary" @click="getQuestReport">Generate Quest Reports</button>
        </div>
        <div class="col-sm-4"></div>
      </div>
    </card>
    <card v-if="activationRan">
      <div class="row">
        <div class="col-sm-2 text-center'">
          <button class="btn btn-primary" @click="getPolicyCSVFile">Get Quest CSV Policy File</button>
        </div>
        <div class="col-sm-2 text-center'">
          <button class="btn btn-primary" @click="getPolicyExcelFile">Get Quest Excel Policy File</button>
        </div>
        <div class="col-sm-2 text-center'">
          <button class="btn btn-primary" @click="getDriverCSVFile">Get Driver CSV Driver File</button>
        </div>
        <div class="col-sm-2 text-center'">
          <button class="btn btn-primary" @click="getDriverExcelFile">Get Driver Excel Driver File</button>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-2 text-center'">
          <button class="btn btn-primary" @click="getVehicleCSVFile">Get Quest CSV Vehicle File</button>
        </div>
        <div class="col-sm-2 text-center'">
          <button class="btn btn-primary" @click="getVehicleExcelFile">Get Quest Excel Vehicle File</button>
        </div>
      </div>
    </card>
    <el-dialog
      center
      title="Success"
      :visible.sync="modals.success">
      <span>{{ success_txt }}</span>
      <span slot="footer" class="dialog-footer">
              <button class="btn btn-success" @click="closeModal('success')">OK</button>&nbsp;
            </span>
    </el-dialog>
    <el-dialog
      center
      title="Error"
      :visible.sync="modals.error"
      width="600px">
      <div class="text-center">
        <i class="nc-icon nc-simple-remove text-danger" style="font-size: 48px;"></i>
        <h4 class="mt-3">Quest Report Error</h4>
        <p class="text-danger">{{ error_txt }}</p>
        <div v-if="error_details" class="mt-3 p-3 bg-light text-left" style="border-radius: 4px; max-height: 200px; overflow-y: auto;">
          <small class="text-muted">
            <strong>Technical Details:</strong><br>
            {{ error_details }}
          </small>
        </div>
        <span slot="footer" class="dialog-footer">
<button class="btn btn-danger mt-3" @click="closeModal('error')">OK</button>&nbsp;
</span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Datepicker from 'vue-moment-datepicker';
import moment from 'moment';
import ReportsAPIHandler from "../../../../servicehandlers/ReportsAPIHandler";
import FilesAPIHandler from "../../../../servicehandlers/FilesAPIHandler";
const reportsAPIHandler = new ReportsAPIHandler();
const filesAPIHandler = new FilesAPIHandler();
import { Dialog } from 'element-ui';
export default {
  name: "QuestReport",
  components: {
    [Dialog.name]: Dialog,
    Datepicker
  },
  data() {
    return {
      excel_claim_file: null,
      policy_csv_filename: null,
      policy_excel_filename: null,
      vehicle_csv_filename: null,
      vehicle_excel_filename: null,
      agent_csv_filename: null,
      agent_excel_filename: null,
      driver_csv_filename: null,
      driver_excel_filename: null,
      spinning: false,
      isRan: false,
      activationRan: false,
      start_date: new Date('2022-09-01'),
      end_date: null,
      success_txt: null,
      error_txt: null,
      error_details: null,
      modals: {
        error: false,
        success:false,
      },
      pollInterval: 1000,
      pollCount: 0,
      maxPollTime: 900000, // 15 minutes in milliseconds
      pollStartTime: null,
      connectionRetries: 0,
      maxConnectionRetries: 5,
      batch_number: null // Store batch number for status checking
    }
  },
  methods: {
    getPolicyExcelFile() {
      const now = moment().format('YYYY-MM-DD');
      this.getCSVActivationFile(this.policy_excel_filename, `${now} ascent quest policy excel file.xlsx`);
    },
    getPolicyCSVFile() {
      const now = moment().format('YYYY-MM-DD');
      this.getCSVActivationFile(this.policy_csv_filename, `${now} ascent quest policy csv file.csv`);
    },
    getVehicleExcelFile() {
      const now = moment().format('YYYY-MM-DD');
      this.getCSVActivationFile(this.vehicle_excel_filename, `${now} ascent quest vehicle excel file.csv`);
    },
    getVehicleCSVFile() {
      const now = moment().format('YYYY-MM-DD');
      this.getCSVActivationFile(this.vehicle_csv_filename, `${now} ascent quest vehicle csv file.csv`);
    },
    getDriverExcelFile() {
      const now = moment().format('YYYY-MM-DD');
      this.getCSVActivationFile(this.driver_excel_filename, `${now} ascent quest driver excel file.csv`);
    },
    getDriverCSVFile() {
      const now = moment().format('YYYY-MM-DD');
      this.getCSVActivationFile(this.driver_csv_filename, `${now} ascent quest driver csv file.csv`);
    },
    getCSVActivationFile(filename, downloadname) {
      this.spinning = true;
      return filesAPIHandler.getFile(filename, this.$router)
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', downloadname); // Set the download attribute to the filename you want
        document.body.appendChild(link);
        link.click();
        this.spinning = false;
      })
      .catch((error) => {
        this.spinning = false;
        this.error_txt = 'Failed to download file';
        this.error_details = error?.response?.data?.message || error?.message || 'The file could not be downloaded. It may not exist or may have been deleted.';
        this.openModal('error');
      });
    },
    getExcelActivationFile() {
      this.spinning = true;
      const now = moment().format('YYYY-MM-DD');
      return filesAPIHandler.getFile(this.policy_excel_filename, this.$router)
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${now} ascent quest policy file.xlsx`); // Set the download attribute to the filename you want
        document.body.appendChild(link);
        link.click();
        this.spinning = false;
      })
      .catch((error) => {
        this.spinning = false;
        this.error_txt = 'Failed to download Excel file';
        this.error_details = error?.response?.data?.message || error?.message || 'The Excel file could not be downloaded.';
        this.openModal('error');
      });
    },
    getQuestReport() {
      if (!this.start_date) {
        this.error_txt = 'No start date!';
        this.openModal('error');
        return;
      }
      if (!this.end_date) {
        this.error_txt = 'No end date!';
        this.openModal('error');
        return;
      }
      this.spinning = true;
      this.activationRan = false;
      // Reset polling state
      this.pollCount = 0;
      this.pollInterval = 1000;
      this.pollStartTime = Date.now();
      this.connectionRetries = 0;

      const start_date = moment(this.start_date).format('MM-DD-YYYY 00:00:00');
      const end_date = moment(this.end_date).format('MM-DD-YYYY 23:59:59');
      return reportsAPIHandler.getQuestReport(start_date, end_date, this.$router)
      .then((response) => {
        // Handle both response structures: response.data.data or response.data
        const responseData = response.data.data || response.data;

        // Store batch_number and filenames from async response
        this.batch_number = responseData.batch_number;
        this.policy_csv_filename = responseData.policy_csv_filename;
        this.policy_excel_filename = responseData.policy_excel_filename;
        this.agent_csv_filename = responseData.agent_csv_filename;
        this.agent_excel_filename = responseData.agent_excel_filename;
        this.vehicle_csv_filename = responseData.vehicle_csv_filename;
        this.vehicle_excel_filename = responseData.vehicle_excel_filename;
        this.driver_csv_filename = responseData.driver_csv_filename;
        this.driver_excel_filename = responseData.driver_excel_filename;

        // now setup polling with exponential backoff to wait for report generation
        this.scheduleNextPoll();
      })
      .catch((error) => {
        this.spinning = false;
        this.error_txt = 'Failed to start report generation';
        this.error_details = error?.response?.data?.message || error?.message || 'Network Error';
        this.openModal('error');
      });
    },
    scheduleNextPoll() {
      // Check if we've exceeded the maximum poll time (15 minutes)
      const elapsedTime = Date.now() - this.pollStartTime;
      if (elapsedTime > this.maxPollTime) {
        this.spinning = false;
        this.error_txt = 'Report generation timed out after 15 minutes. Please contact support if the issue persists.';
        this.openModal('error');
        return;
      }

      // Calculate next poll interval with exponential backoff (max 30 seconds)
      this.pollCount++;
      if (this.pollCount > 5) {
        this.pollInterval = Math.min(5000, this.pollInterval * 1.5);
      }
      if (this.pollCount > 20) {
        this.pollInterval = Math.min(30000, this.pollInterval * 1.2);
      }

      this.timerId = setTimeout(this.getFileStatus, this.pollInterval);
    },
    async getFileStatus() {
      this.spinning = true;

      // Use new batch-based status check API
      await reportsAPIHandler.checkQuestReportStatus(this.batch_number, this.$router)
      .then((response) => {
        // NOTE: CommonHandler.getCall returns response.data, so 'response' here is already the data object
        if (!response || !response.status) {
          throw new Error('Invalid response from status check endpoint');
        }

        if (response.status === 'completed') {
          // Report is complete!
          this.activationRan = true;
          this.connectionRetries = 0;

          if (this.timerId) {
            clearTimeout(this.timerId);
            this.timerId = null;
          }

          this.spinning = false;
          const totalTime = Math.floor((Date.now() - this.pollStartTime) / 1000);
          this.success_txt = `Report generated successfully in ${Math.floor(totalTime/60)} minutes and ${totalTime%60} seconds!`;
          this.openModal('success');
        } else if (response.status === 'processing') {
          // Still processing, reset connection retries since we got a successful response
          this.connectionRetries = 0;
          // Schedule next poll
          this.scheduleNextPoll();
        } else {
          // Unknown status
          this.scheduleNextPoll();
        }
      })
      .catch((error) => {
        this.connectionRetries++;

        if (this.connectionRetries >= this.maxConnectionRetries) {
          this.error_txt = 'Connection failed multiple times. Please check your internet connection and try again.';
          this.error_details = `Error occurred after ${this.connectionRetries} retry attempts. Last error: ${error?.response?.data?.message || error?.message || 'Network connection failed'}`;
          this.openModal('error');
          if (this.timerId) {
            clearTimeout(this.timerId);
            this.timerId = null;
          }
          this.spinning = false;
        } else {
          // Retry with exponential backoff - don't show error modal yet
          this.scheduleNextPoll();
        }
      });
    },
    customFormatter(date) {
      return moment(date).utc().format('YYYY-MM-DD');
    },
    formatElapsedTime() {
      if (!this.pollStartTime) return '';
      const elapsedTime = Date.now() - this.pollStartTime;
      const minutes = Math.floor(elapsedTime / 60000);
      const seconds = Math.floor((elapsedTime % 60000) / 1000);
      return `${minutes}m ${seconds}s`;
    },
    openModal(name) {
      this.modals[name] = true
    },
    closeModal(name) {
      this.modals[name] = false
    },
  },
  beforeDestroy() {
    // Clean up the timer when component is destroyed
    if (this.timerId) {
      clearTimeout(this.timerId);
      this.timerId = null;
    }
  }
}
</script>

<style scoped>

</style>
